export const isCompositionEmpty = (composition) => {
    return (composition.components.instruments.length === 0 &&
        composition.components.cash.length === 0 &&
        composition.components.others === 0);
};
